import callRefFunc from 'src/utils/callRefFunc';
import Vue from 'vue';
export default Vue.extend({
    props: {
        ['value']: { type: String },
        ['label']: { type: String },
        ['inputHandler']: { type: Function },
        ['qInputProps']: { type: Object },
        ['qInputClasses']: { type: String },
        ['qTimeProps']: { type: Object },
        ['editable']: { type: Boolean, default: true }
    },
    data() {
        return {
            valueHolder: ''
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.valueHolder = newVal || '';
            }
        }
    },
    methods: {
        cancel() {
            callRefFunc(this, 'qTimePopupProxy', 'hide');
        },
        ok() {
            this.handleInput(this.valueHolder, this.value);
        },
        handleInput(newVal, oldVal) {
            this.$emit('input', newVal);
            if (typeof this.inputHandler === 'function')
                this.inputHandler(newVal);
            callRefFunc(this, 'qTimePopupProxy', 'hide');
        }
    }
});
